(() => {
  const initialize = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
    if (reduceMotion || !window.Lenis) return;

    // Los carruseles y paneles con scroll propio no pasan por Lenis, así Lenis no recorre el DOM en cada evento.
    const nestedScroll = '.pd-cart-drawer__body,.pd-cart-look,.pd-collection__sidebar,.pd-collection__teams-track,.pd-header__league-panels,.pd-header__mobile-links,.pd-home__feature-thumbs,.pd-product__modal-card,.pd-product__thumbs,.pd-recommended__track,.pd-retro__viewport,[role="dialog"],dialog,.drawer,[data-pd-scroll]';

    // En táctil el scroll sigue al dedo con una inercia corta; en rueda, un lerp algo más alto responde más rápido.
    const lenis = new window.Lenis({
      autoRaf: true,
      smoothWheel: true,
      syncTouch: coarsePointer,
      syncTouchLerp: 0.12,
      touchInertiaExponent: 1.7,
      lerp: 0.1,
      wheelMultiplier: 1,
      anchors: true,
      prevent: (node) => node.closest?.(nestedScroll) != null
    });

    window.pdLenis = lenis;
    document.addEventListener('visibilitychange', () => (document.hidden ? lenis.stop() : lenis.start()));
    window.addEventListener('pagehide', () => lenis.destroy(), { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
